// English translations (default)
const en = {
  header: {
    news: "NEWS",
    servers: "SERVERS",
    faq: "F.A.Q.",
    market: "MARKET",
  },
  footer: {
    navigation: "Navigation",
    information: "Information",
    home: "Home",
    news: "News",
    market: "Market",
    faq: "FAQ",
    userAgreement: "User Agreement",
    rules: "Rules",
    privacyPolicy: "Privacy Policy",
    disclaimer:
      "S.T.A.L.K.E.R.S Reborn is not affiliated with or endorsed by GSC Game World or any other rights holder. All trademarks belong to their respective owners.",
    allRightsReserved: "All rights reserved.",
  },
  main: {
    crossPerimeter: "CROSS THE PERIMETER",
    exploreZone: "Explore the Zone",
    leaderboards: "Leaderboards",
    online: "ONLINE",
    offline: "OFFLINE",
  },
  news: {
    title: "News",
    olderPosts: "Older posts",
    stayInformed: "Stay informed with our latest insights",
    loadMore: "Load more",
    noPosts: "No posts yet",
    networkErrorTitle: "Failed to load news",
    networkErrorText:
      "Try refreshing the page and loading the news feed again.",
    createPost: "Create new post",
    deleteConfirm: "Delete this post?",
  },
  servers: {
    title: "Servers",
    subtitle: "Connect to our servers and join the Zone",
    online: "Online",
    offline: "Offline",
    noServers: "No servers available",
    networkErrorTitle: "Failed to load servers",
    networkErrorText:
      "Try refreshing the page and loading server status again.",
    connect: "Connect",
    copied: "Copied!",
    copyIp: "Copy IP",
    noIpAvailable: "No IP available",
    notAvailable: "Not available",
    connectCopyIp: "Connect (copy IP)",
    activity24h: "24h Activity",
    peak24h: "24h Peak",
    avg24h: "24h Avg",
    uptime24h: "24h Uptime",
    noDataAvailable: "No data available",
    onlineNow: "online now",
    peakOnline: "peak online",
    peakAllTime: "peak all time",
    serversOnline: "servers online",
    serverStatistics: "Server Statistics",
  },
  market: {
    title: "Market",
    subtitle: "Browse and acquire equipment for your journey through the Zone",
    signInPrompt: "Sign in to start purchasing items",
    networkErrorTitle: "Failed to load market",
    networkErrorText: "Try refreshing the page and loading the catalog again.",
    purchaseComplete: "Purchase Complete!",
    purchaseFailed: "Purchase Failed",
    purchaseMessage: "Your items have been purchased successfully.",
    totalCost: "Total Cost",
    newBalance: "New Balance",
    itemsPurchased: "Items Purchased",
    processing: "Processing...",
    shoppingCart: "Shopping Cart",
    cartSubtitle: "Review your items before checkout.",
    closeCart: "Close cart",
    cartEmpty: "Your cart is empty",
    addItemsPrompt: "Add some items to get started!",
    items: "Items",
    itemLabel: "Item",
    unitPrice: "Unit price",
    quantity: "Quantity",
    itemTotal: "Total",
    cartStage: "Cart",
    purchaseStage: "Purchase",
    receiptStage: "Receipt",
    nextStep: "Next Step",
    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    checkout: "Checkout",
    continueShopping: "Continue shopping",
    promoCode: "Promo code",
    applyPromo: "Apply",
    promoUnavailable: "Promo codes are not available yet",
    securePayment: "Secure payment through Steam.",
    dataProtected: "Your data stays protected.",
    allSalesFinal: "All purchases are final and cannot be refunded.",
    needHelp: "Need help?",
    clearCart: "Clear Cart",
    clearCartMobile: "Clear",
    clearCartConfirm: "Are you sure you want to clear your cart?",
    removeItemFromCart: "Remove item from cart",
    removeSelected: "Remove selected",
    itemsSelected: "items selected",
    selectItem: "Select item",
    decreaseQuantity: "Decrease quantity",
    increaseQuantity: "Increase quantity",
    categoryArmor: "Armor",
    categoryWeapons: "Weapons",
    categoryFood: "Food & drink",
    marketItemLabel: "Market item",
    purchasedItems: "Purchased Items",
    noItemsTitle: "No Items Found",
    noItemsText: "Try adjusting your filters or check back later.",
    loadMore: "Show More Items",
    loadingMore: "Loading more items...",
  },
  faq: {
    title: "F.A.Q.",
    subtitle: "Frequently Asked Questions",
    mainQuestions: "Main Questions",
    clarifications: "Clarifications",
    noQuestions: "No questions yet.",
    noClarifications: "No clarifications yet.",
  },
  common: {
    loginWithSteam: "LOGIN WITH STEAM",
    voteForServer: "Vote for Server",
    donate: "Donate",
    exit: "Exit",
    buyNow: "BUY NOW",
    getLauncher: "GET LAUNCHER",
    viewServers: "VIEW SERVERS",
    getGame: "GET THE GAME",
    yes: "Yes",
    no: "No",
    close: "Close",
    closeModal: "Close modal",
    error: "Error",
    retry: "Retry",
  },
  leaderboard: {
    zonePresence: "ZONE PRESENCE",
    moneyEarned: "MONEY EARNED",
    legendsOfZone: "LEGENDS OF THE ZONE",
    hours: " hours",
  },
  steps: {
    getGame: {
      title: "GET THE GAME",
      description:
        "New to DayZ? Grab it on Steam and gear up. Launch once to generate configs. You're ready to jump in.",
    },
    installLauncher: {
      title: "INSTALL LAUNCHER",
      description:
        "Install DZSALauncher to auto-manage mods. It finds, downloads, and updates everything. Stay synced with a single click.",
    },
    browseServers: {
      title: "BROWSE SERVERS",
      description:
        "Browse our server list and pick your next adventure. See populations, mods, and ping at a glance. Join with one click via DZSALauncher.",
    },
  },
  userPanel: {
    voteForServer: "Vote for Server",
    donate: "Donate",
    exit: "Exit",
    openUserMenu: "Open user menu",
    userInfo: "User info",
  },
  language: {
    english: "English",
    ukrainian: "Українська",
  },
};

export default en;
